/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-unused-vars */
/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { PAGE_SIZE } from './constant';
import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer';
import JsBarcode from 'jsbarcode';
import Footer from './Footer.web';

import RenderIf from '@components/global/RenderIf';

import { imageSource, currency } from '@global/helpers';

const PdfCatalog = ({ data }) => {
  const generateBarcode = (value) => {
    try {
      // Create a canvas element
      const canvas = document.createElement('canvas');

      // Generate barcode
      JsBarcode(canvas, value, {
        displayValue: false,
        height: 50,
      });

      // Convert canvas to data URL
      const res = canvas.toDataURL('image/png');
      return res;
    } catch (error) {
      console.error('Error generating barcode:', error);
      return null;
    }
  };
  return (
    <Document>
      <Page size={PAGE_SIZE} style={styles.page} wrap>
        {(data || []).map((b, i) => (
          <View key={i} style={{ marginBottom: 20 }}>
            <View style={styles.brandWrapper}>
              <Image src={imageSource(b.logo)} style={styles.brandLogo} />
            </View>

            <View style={styles.productWrapper}>
              {(b.products || []).map((p, i) => (
                <View key={i} style={styles.productContainer}>
                  {/* Product */}
                  <View style={styles.productRow} wrap={false}>
                    <View style={styles.productDesc}>
                      <Image
                        src={imageSource(p.images)}
                        style={styles.productImage}
                      />
                      <View>
                        <Text style={{ marginBottom: 5 }}>
                          [{p.combinations[0]?.reference}]
                        </Text>
                        <Text style={{ fontWeight: 700 }}>{p.name}</Text>
                        <Text style={{ fontStyle: 'italic' }}>
                          {p.default_category?.name || '-'}
                        </Text>
                      </View>
                    </View>
                    <View style={styles.productPrice}>
                      <Text style={{ fontWeight: 700 }}>
                        {p.combinations[0]?.price == 'Not Set'
                          ? '-'
                          : currency(p.combinations[0]?.price, true)}
                      </Text>
                    </View>
                    <View style={styles.productBarcodeWrapper}>
                      <Image
                        src={generateBarcode(p.combinations[0]?.ean_no)}
                        style={styles.productBarcodeImage}
                      />
                      <Text style={{ fontSize: 6 }}>
                        {p.combinations[0]?.ean_no}
                      </Text>
                    </View>
                  </View>

                  {/* Combination */}
                  <RenderIf condition={p.combinations?.length > 1}>
                    <View style={styles.productCombContainer}>
                      {(p.combinations || []).map((comb, i) => (
                        <View
                          key={comb._id}
                          style={styles.productCombWrapper(i)}
                          wrap={false}>
                          <Image
                            src={comb.combination_image}
                            style={[styles.productImage, { width: '20%' }]}
                          />
                          <View style={styles.productCombDesc}>
                            <Text>[{comb.reference}]</Text>
                            <Text>{comb.variant}</Text>
                            <Text style={{ fontWeight: 700 }}>
                              {comb.price == 'Not Set'
                                ? '-'
                                : currency(comb.price, true)}
                            </Text>
                          </View>
                          <View
                            style={[
                              styles.productBarcodeWrapper,
                              { width: '30%' },
                            ]}>
                            <Image
                              src={generateBarcode(comb.ean_no)}
                              style={styles.productBarcodeImage}
                            />
                            <Text style={{ fontSize: 6 }}>{comb.ean_no}</Text>
                          </View>
                        </View>
                      ))}
                    </View>
                  </RenderIf>
                </View>
              ))}
            </View>
          </View>
        ))}

        <Footer />
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 15,
    fontSize: 10,
    color: '#000',
    fontFamily: 'Roboto',
    paddingBottom: 30,
    paddingHorizontal: 20,
  },

  brandWrapper: {
    width: '100%',
    alignItems: 'center',
    borderBottom: '1px solid #d5d5d5',
    marginBottom: 20,
  },
  brandLogo: {
    width: 80,
  },

  productWrapper: {
    fontSize: 8,
  },
  productContainer: {
    marginVertical: 5,
  },
  productRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    padding: 5,
    borderRadius: 8,
  },
  productImage: {
    width: 50,
    border: '2px solid #e2e2e2',
    borderRadius: 8,
    marginRight: 15,
  },
  productDesc: {
    width: '50%',
    flexDirection: 'row',
    alignItems: 'center',
  },
  productPrice: {
    width: '30%',
    alignItems: 'center',
  },
  productBarcodeWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '20%',
    height: 50,
  },
  productBarcodeImage: {
    width: '100%',
  },

  productCombContainer: {
    flexDirection: 'row',
    width: '100%',
    flexWrap: 'wrap',
    paddingHorizontal: 10,
  },
  productCombWrapper: (i) => ({
    width: '48%',
    flexDirection: 'row',
    marginVertical: 10,
    borderRight: `${i % 2 === 0 ? '1px' : '0px'} solid #e2e2e2`,
    marginRight: i % 2 === 0 ? '2%' : 0,
    paddingRight: i % 2 === 0 ? '2%' : 0,
  }),
  productCombDesc: {
    justifyContent: 'space-evenly',
    width: '50%',
  },
});

export default PdfCatalog;
